<script setup>
import { DmFileUpload } from 'dmui_components'
import SpreadsheetFileReader from '@/utility/SpreadsheetFileReader.js'

defineProps({
	readonly: {
		type: Boolean,
		default: false
	}
})

const spreadsheetFileReader = new SpreadsheetFileReader()

const emit = defineEmits(['upload'])

async function onUploadData(spreadsheet) {
	emit('upload', spreadsheet)
}
</script>

<template>
	<div v-if="!readonly" class="iro-upload">
		<DmFileUpload id="upload" accept=".xlsx" :max-size-mb="5" :reader="spreadsheetFileReader" @update:data="onUploadData" />
	</div>
</template>

<style scoped lang="less">
.iro-upload {
	position: absolute;
	margin-top: -60px;
	right: 0;
}
</style>
